// appLyricsAdv — ekran „Opcje zaawansowane” tekstu utworu: „Cięcie i klej”, tryb
// „Edycja”, sylaby, przesunięcie czasów, szablony łamań. Klucze lustrzane
// z ../en/appLyricsAdv.ts.
//
// ZASADA TEGO EKRANU: ręczna korekta tekstu to godziny pracy artysty. Każda
// operacja, która może ją nadpisać, mówi DOKŁADNIE co zniknie i ile tego jest —
// nigdy „czy na pewno?”. Stąd liczniki w oknach „Wyczyścić ręczne?” i „Wczytać…?”.
//
// ZASADA 8 (MINIMAL, runda R4b sesji 32): zdania tłumaczące mechanikę wyleciały.
// „Kliknij przerwę między słowami”, „Kolejne kliknięcie przełącza…”, „Sklejenie
// i łamanie wykluczają się…”, „Ctrl+Z cofa każdy krok” — wszystkie cztery uczyły
// tego, co teraz widać: kontrolka jest szara tam, gdzie operacja jest niemożliwa,
// a skróty stoją w legendzie pod listą. Tekst, który powtarza obraz, zabiera mu
// miejsce.
//
// LICZBY W ZDANIACH: `t()` nie ma wyboru formy mnogiej, a liczba na tym ekranie
// zawsze stoi APOZYCYJNIE („Słowa: 54”) albo w parze „{n} / {max}” — poprawnie
// dla każdej liczby, bez maszynerii odmiany.
export const appLyricsAdv = {
  // ── „Cięcie i klej”: wiersz listy = jeden klip napisu ───────────────────────
  // Celem jest SŁOWO, a operacja dotyczy granicy PRZED nim. Dwie jawne akcje
  // zamiast ukrytego cyklu trzech stanów w jednym kliknięciu.
  cutGlue: {
    title: 'Cięcie i klej',
    cutHere: 'Tnij tutaj',
    joinRows: 'Złącz wiersze',
    glue: 'Sklej',
    unglue: 'Rozklej',
    joinPrev: 'Złącz z poprzednim',
    tooLongShort: 'za długi',
    // Jedno zdanie dymka pierwszego wejścia — pasuje i do palca, i do myszy.
    styleLabel: 'Styl docelowy',
    targetLabel: 'Styl docelowy',
  },
  // Legenda skrótów pod listą (1440). Mówi, co robi klawisz, nie jak się nazywa.
  legend: {
    boundary: 'granica',
    cut: 'tnij',
    joinGlue: 'złącz / sklej',
    unglue: 'rozklej',
    play: 'odtwarzaj',
    undo: 'cofnij',
    redo: 'ponów',
  },
  // Granica jest elementem z nazwą — przyciskiem w porządku czytania między słowami.
  boundary: {
    label: 'granica przed słowem {word}: {state}',
    stateAuto: 'automat',
    stateCut: 'koniec klipu',
    stateGlued: 'sklejone',
  },
  // Komunikaty do regionu `aria-live`: operacja bez własnego widoku dla czytnika.
  live: {
    cut: 'Wiersz podzielony przed słowem {word}',
    glue: 'Sklejono {a} i {b}',
    joined: 'Wiersze złączone',
    unglued: 'Rozklejono {a} i {b}',
  },
  meter: {
    label: 'Pojemność zestawu: {n} z {max}',
  },
  empty: 'Brak słów do edycji',
  emptyAction: 'Edytuj tekst',
  save: 'Zapisz',
  saving: 'Zapisuję…',
  saved: 'Zapisano',
  unsaved: 'Niezapisane zmiany',
  error: {
    // Kod błędu stoi obok, a „Zapisz” jest nadal aktywny: droga naprawy jest
    // widoczna, więc zdanie „Spróbuj ponownie.” nie miało czego dodać.
    save: 'Nie udało się zapisać.',
    retry: 'Spróbuj ponownie',
  },
  advanced: {
    toggle: 'Opcje zaawansowane',
    // Okno przy wejściu z niezapisanym tekstem. Ekran pracuje na OSTATNIO
    // ZAPISANEJ wersji utworu, więc jedno zdanie mówi to wprost, a druga akcja
    // od razu zapisuje — zamiast odsyłać z powrotem po nic.
    saveFirstTitle: 'Otworzyć opcje zaawansowane?',
    saveFirst: 'Opcje zaawansowane pracują na ostatnio zapisanej wersji.',
    saveFirstConfirm: 'Zapisz i otwórz',
    saveFirstCancel: 'Anuluj',
  },
  mode: {
    label: 'Tryb',
    edit: 'Edycja',
    accents: 'Cięcie i klej',
  },
  tool: {
    glue: 'Sklej',
    split: 'Podziel',
    syllables: 'Na sylaby',
    merge: 'Scal słowa',
    mergeShort: 'Scal',
    delete: 'Usuń słowo',
    insert: 'Wstaw słowo',
    insertShort: 'Wstaw',
    undo: 'Cofnij',
    redo: 'Ponów',
  },
  more: {
    label: 'Więcej akcji',
  },
  timeline: {
    minimap: 'Cały utwór',
    // Fala rysuje się osobno od transkrypcji — mówimy, że jej brak jest chwilowy.
    wavePending: 'Rysuję falę dźwięku…',
    // Oś nie znika, gdy fala się nie wczyta — więc trzeba powiedzieć, SKĄD bierze
    // się kształt, który człowiek nadal widzi. Bez tego zdania wygląda on jak
    // wykres dźwięku i ktoś zacznie po nim ciąć.
    waveUnavailable: 'Fala dźwięku jest niedostępna. Kształt na osi pochodzi z rozłożenia słów, nie z nagrania.',
    waveRetry: 'Ponów próbę',
    gap: 'przerwa {s}',
    play: 'Odtwórz',
    pause: 'Pauza',
    nudgeEarlier: '-{step} s',
    nudgeLater: '+{step} s',
    selectedWord: 'Zaznaczone słowo',
  },
  zoom: {
    label: 'Przybliżenie',
    in: 'Przybliż',
    out: 'Oddal',
    reset: 'Dopasuj do okna',
    lock: 'Zablokuj przybliżenie',
  },
  playhead: {
    follow: 'Podążaj za odtwarzaniem',
    noAudio: 'Brak pliku audio - oś czasu działa, odtwarzanie nie.',
  },
  // Tryb „Edycja”: te same słowa, co w „Cięciu i kleju”, tylko celem jest samo
  // słowo, a nie granica przed nim.
  words: {
    title: 'Słowa',
    label: 'słowo {word}',
    labelLow: 'słowo {word}, do sprawdzenia',
    // Liczba apozycyjnie — poprawne dla 1, 2 i 5 bez odmiany.
    lowConfidence: 'Do sprawdzenia: {n}',
    filterLow: 'Do sprawdzenia',
    noLow: 'Wszystkie słowa rozpoznane pewnie.',
    noLowAction: 'Pokaż wszystkie',
    fix: 'Popraw',
    editLabel: 'Edytuj słowo {n}',
    keyCommit: 'zapisz słowo',
    keyCancel: 'porzuć zmianę',
    keyDelete: 'usuń słowo',
    keyUndo: 'cofnij',
    undoTitle: 'Cofnij ostatnią zmianę',
  },
  // Zestaw łamań: domyślny albo osobny dla kategorii stylu (np. krótkie style).
  target: {
    label: 'Zestaw łamań',
    default: 'Domyślny',
    category: '{name}',
  },
  autofill: {
    cta: 'Rozstaw automatycznie',
    done: 'Rozstawione łamania: {count}',
  },
  clear: {
    ctaManual: 'Wyczyść ręczne',
    title: 'Wyczyścić ręczne?',
    keep: 'Słowa i czasy zostają.',
    rowSet: 'Zestaw',
    rowCuts: 'Własne cięcia',
    rowGlues: 'Sklejenia',
  },
  shots: {
    preview: 'Podgląd',
    previewClose: 'Zamknij podgląd',
    // `{duration}` = REALNY czas klipu z czasów słów („3,2 s”), nigdy nazwa stylu.
    previewMeta: 'klip {index} · {duration}',
    noFrame: 'Kadr będzie',
    seconds: '{s} s',
  },
  dialog: {
    cancel: 'Anuluj',
  },
  retranscribe: {
    cta: 'Transkrybuj od nowa',
    title: 'Stracisz swoje poprawki',
    lossHead: 'Co przepadnie',
    lossWords: 'poprawione słowa',
    lossBreaks: 'łamania linii',
    lossGlues: 'sklejenia sylab',
    lossTemplates: 'zapisane szablony tekstu',
    // Potwierdzenie przez przepisanie słowa — jedyna bariera, której nie da się
    // kliknąć odruchowo. `confirmWord` MUSI być JEDNYM słowem bez spacji i bez
    // znaków trudnych do wpisania: user przepisuje je z ekranu, żeby odblokować
    // przycisk, więc dwuwyrazowe tłumaczenie wyłącza bramkę w drugim języku.
    typeToConfirm: 'Wpisz {word}, żeby potwierdzić',
    confirmWord: 'USUŃ',
    failSafe: 'Nieudana transkrypcja niczego nie skasuje.',
    confirm: 'Transkrybuj',
    working: 'Transkrybuję…',
    queued: 'W kolejce - transkrypcja ruszy za chwilę.',
    failed: 'Transkrypcja się nie udała. Twoje poprawki są nietknięte.',
  },
  syllables: {
    title: 'Podziel „{word}” na sylaby',
    before: 'PRZED',
    after: 'PO',
    confirm: 'Podziel',
    // Okno w blokadzie pokazuje PO równe PRZED i szarą akcję; POWÓD (słowo ma
    // jedną sylabę albo jest za krótkie) niesie nazwa dla czytnika, nie zdanie.
    blocked: 'Tego słowa nie da się podzielić',
  },
  shift: {
    cta: 'Przesuń czasy',
    title: 'Przesuń czasy',
    hint: 'Gdy cała transkrypcja jest o ułamek sekundy spóźniona.',
    fromHereRight: 'Od tego słowa w prawo',
    toHereLeft: 'W lewo',
    amount: 'Przesunięcie',
    preview: 'Podgląd',
    wordCount: 'Słowa: {n}',
    // Powód wyłączonego „Przesuń 0” — wyłącznie dla czytnika i w `title`.
    blocked: 'Przesunięcie wynosi zero sekund, więc żadne słowo nie zmienia czasu.',
    clamped: 'Część słów dobiła do początku albo końca utworu - te zostały na miejscu.',
    confirm: 'Przesuń {n}',
  },
  trim: {
    cta: 'Przytnij utwór',
    title: 'Przytnij utwór',
    from: 'Od',
    to: 'Do',
    fadeIn: 'Wyciszenie na wejściu',
    fadeOut: 'Wyciszenie na wyjściu',
    newTrackNote: 'Powstanie nowy utwór - oryginał zostaje nietknięty.',
    confirm: 'Przytnij {span}',
    working: 'Przycinam…',
    done: 'Gotowe. Przeniesione słowa: {n}',
    failed: 'Nie udało się przyciąć. Oryginał jest nietknięty.',
    tooShort: 'Fragment jest za krótki - wybierz co najmniej sekundę.',
  },
  template: {
    menu: 'Szablony łamań',
    name: 'Nazwa szablonu',
    namePlaceholder: 'np. Krótkie style',
    save: 'Zapisz szablon',
    saving: 'Zapisuję…',
    words: 'Słowa: {n}',
    delete: 'Usuń szablon',
    deleted: 'Usunięto „{name}”',
    loaded: 'Wczytano „{name}”',
    loadTitle: 'Wczytać „{name}”?',
    loadConfirm: 'Wczytaj',
    overwriteNote: 'Wczytanie szablonu zastąpi obecne łamania w tym zestawie.',
    nameTaken: 'Masz już szablon o tej nazwie.',
    saveError: 'Nie udało się zapisać szablonu. Twoje łamania są nietknięte.',
    loadError: 'Nie udało się wczytać szablonu. Nic nie zostało zmienione.',
    deleteError: 'Nie udało się usunąć szablonu.',
  },
}
